import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {format, formatDate, OFFSET_OPTIONS, SCHEDULE_FORMATDATE} from 'src/app/utils/contants'
import {NgbCalendar, NgbDate} from "@ng-bootstrap/ng-bootstrap";
import {ScheduleDetails, ScheduleVersionDetail, ScheduleVersionRequest} from 'src/app/pages/schedules/schedule';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-schedule-header',
  templateUrl: './schedule-header.component.html',
  styleUrls: ['./schedule-header.component.scss'],
})
export class SchedulesHeaderComponent implements OnInit {
  // Accessors
  @Input() hasEvent = false;
  @Input() checkAll = false;
  @Input() checkAllIndeterminate = false;
  @Input() isSchedulesLoading = false;
  @Input() updateScheduleDate: Function;
  @Input() updateTimezone: Function;
  @Input() request: ScheduleVersionRequest;
  @Input() schedules: ScheduleDetails[] = [];
  @Input() readOnlyMode = false;

  @Output() onShowOrHideProgramPanel: EventEmitter<boolean> = new EventEmitter();
  @Output() onCheckAllEvents: EventEmitter<boolean> = new EventEmitter();
  @Output() onDisplayProgramPanel: EventEmitter<boolean> = new EventEmitter();

  // private fields
  shouldHideProgramPanel = true;
  TODAY: NgbDate = this.calendar.getToday();
  offsetOptions = OFFSET_OPTIONS;
  hoveredDate: NgbDate;
  showTimezoneDropDown = false;

  // Life cycle methods
  constructor(private calendar: NgbCalendar,) {
  }

  ngOnInit() {
  }

  // Show or hide the timezone dropdown list.
  toggleRenderTimezoneDropdown() {
    this.showTimezoneDropDown = !this.showTimezoneDropDown;
  }

  // Used by the datepicker to set the UX on datepicker.
  isRange(selectedDate: NgbDate) {
    const fromDate = this.TODAY;
    const toDate = this.calendar.getNext(fromDate, 'd', 13)
    return (
      selectedDate.equals(fromDate) ||
      (toDate && selectedDate.equals(toDate)) ||
      this.isInside(selectedDate) ||
      this.isHovered(selectedDate)
    );
  }

  // Used by the datepicker to highlight selected date.
  isInside(selectedDate: NgbDate) {
    const fromDate = this.TODAY;
    const toDate = this.calendar.getNext(fromDate, 'd', 13)
    return toDate && selectedDate.after(fromDate) && selectedDate.before(toDate);
  }

  // Used by the datepicker to highlight 14 days (from today) as the range of the current schedule.
  isHovered(selectedDate: NgbDate) {
    const fromDate = this.TODAY;
    const toDate = this.calendar.getNext(fromDate, 'd', 13)
    return (
      fromDate &&
      !toDate &&
      this.hoveredDate &&
      selectedDate.after(fromDate) &&
      selectedDate.before(this.hoveredDate)
    )
  }

  // Handle checking all events on UI.
  onCheckAllScheduleEvents($event) {
    this.onCheckAllEvents.emit($event.target.checked);
  }

  toggleProgramPanel() {
    this.shouldHideProgramPanel = !this.shouldHideProgramPanel;
    this.onDisplayProgramPanel.emit(this.shouldHideProgramPanel);
  }

  changeScheduleDate(isNext: boolean) {
    let currentScheduleDate = dayjs.tz(formatDate(this.request.date), SCHEDULE_FORMATDATE, "UTC")
    if (isNext) {
      this.updateScheduleDate(format(currentScheduleDate.add(1, 'day'), SCHEDULE_FORMATDATE))
    } else {
      this.updateScheduleDate(format(currentScheduleDate.add(-1, 'day'), SCHEDULE_FORMATDATE))
    }
  }

  getHeaderVersionText(): string {
    const scheduleVersion = this.schedules?.find(schedule => schedule?.version != null && schedule?.status !== 'NEW')?.version;
    const versionLabel = scheduleVersion ?? '-';
    const channelLabel = this.request?.channel?.sourceId || this.request?.channel?.id || 'N/A';
    return `Version: ${versionLabel} | ${channelLabel}`;
  }

  isContentLocked(): boolean {
    const scheduleContentLock = this.schedules?.find(schedule => schedule?.contentLock != null)?.contentLock;
    return !!scheduleContentLock;
  }
}
